import React from 'react';
import {TextStyle, View, ViewStyle} from 'react-native';
import {noop} from 'lodash';

import Text from '/component/base/Text';
import TouchableOpacity from '/component/base/TouchableOpacity';
import {withCompetency, withTheme} from '/provider/ThemeProvider';
import {withHOC} from '/util/hoc.util';
import testProperties from '/util/testing/testProperties';

import {styles} from './Button.style';

type ButtonType =
  | 'primary'
  | 'secondary'
  | 'textLink'
  | 'secondaryTextLink'
  | 'destructive';
interface ButtonProps {
  getTheme: (key: string) => string;
  style: {
    base: ViewStyle;
    text: TextStyle;
  };
  onPress: () => void;
  type: ButtonType;
  disabled: boolean;
  children: React.ReactNode;
  testID: string;
  labelTestID?: string;
  accessible: boolean;
  accessibilityLabel: string;
  buttonRef: ((instance: any) => void) | React.RefObject<any>;
  focusable?: boolean;
  webID?: string;
}

export const Button: React.FC<ButtonProps> = ({
  getTheme = noop,
  style: styleProp = {},
  onPress = noop,
  type = 'primary',
  disabled = false,
  children = 'Button',
  testID = null,
  labelTestID = null,
  accessible = true,
  accessibilityLabel = null,
  buttonRef = null,
  focusable = true,
  webID = undefined,
}: any) => {
  const style = [styles.base];

  if (type === 'primary') {
    // @ts-expect-error TS(2345): Argument of type '{ paddingHorizontal: number; }' ... Remove this comment to see the full error message
    style.push(styles.primary);
    style.push(getTheme('competency.backgroundColor'));

    if (disabled) {
      // @ts-expect-error TS(2345): Argument of type '{ backgroundColor: string; }' is... Remove this comment to see the full error message
      style.push(styles.primaryDisabled);
    }
  } else if (type === 'secondary') {
    // @ts-expect-error TS(2345): Argument of type '{ borderWidth: number; borderSty... Remove this comment to see the full error message
    style.push(styles.secondary);
  } else if (type === 'textLink') {
    // @ts-expect-error TS(2345): Argument of type '{ minWidth: number; }' is not as... Remove this comment to see the full error message
    style.push(styles.textLink);
  } else if (type === 'secondaryTextLink') {
    // @ts-expect-error TS(2345): Argument of type '{ minWidth: number; }' is not as... Remove this comment to see the full error message
    style.push(styles.secondaryTextLink);
  } else if (type === 'destructive') {
    // @ts-expect-error TS(2345): Argument of type '{ backgroundColor: string; paddi... Remove this comment to see the full error message
    style.push(styles.destructive);

    if (disabled) {
      // @ts-expect-error TS(2345): Argument of type '{ backgroundColor: string; }' is... Remove this comment to see the full error message
      style.push(styles.destructiveDisabled);
    }
  }

  style.push(styleProp.base);

  let textStyle = {};
  let textVariant = 'button';

  if (type === 'primary') {
    textStyle = styles.primaryText;
  } else if (type === 'secondary') {
    textStyle = styles.secondaryText;

    if (disabled) {
      textStyle = {...textStyle, ...styles.secondaryTextDisabled};
    }
  } else if (type === 'textLink') {
    textStyle = getTheme('competency.textColor');

    if (disabled) {
      textStyle = {...textStyle, ...styles.textLinkTextDisabled};
    }

    textVariant = 'body';
  } else if (type === 'secondaryTextLink') {
    textStyle = styles.secondaryLinkText;

    if (disabled) {
      textStyle = {...textStyle, ...styles.secondaryLinkTextDisabled};
    }

    textVariant = 'body';
  } else if (type === 'destructive') {
    textStyle = styles.destructiveText;
  }

  textStyle = {...textStyle, ...(styleProp.text || {})};
  if (disabled) {
    return (
      <View {...testProperties(testID)} style={style}>
        <Text
          allowFontScaling
          maxFontSizeMultiplier={2}
          variant={textVariant}
          style={textStyle}>
          {children}
        </Text>
      </View>
    );
  } else {
    return (
      <TouchableOpacity
        // {...testProperties(testID, true)}
        testID={testID}
        onPress={onPress}
        accessibilityRole={
          typeof children === 'string' &&
          children.trim().toLowerCase() === 'learn more'
            ? 'link'
            : 'button'
        }
        accessible={accessible ?? true}
        accessibilityLabel={accessibilityLabel || ''}
        focusable={focusable}
        webID={webID}
        style={style}
        ref={buttonRef}>
        <Text
          allowFontScaling
          maxFontSizeMultiplier={2}
          testID={labelTestID}
          variant={textVariant}
          style={textStyle}
          accessible={false}
          importantForAccessibility="no-hide-descendants">
          {children}
        </Text>
      </TouchableOpacity>
    );
  }
};

export default withHOC(withTheme, withCompetency)(Button);
